import Cookies from 'js-cookie';

import request from '../request';
const AI_API = process.env.NODE_ENV == 'development' ? '/ai' : process.env.AI_API;
const AGENT_STREAM_API_HOST =
  process.env.NODE_ENV == 'development' ? '/api/agent' : process.env.AGENT_HOST;
const AGENT_HOST = process.env.NODE_ENV == 'development' ? '/agent' : process.env.AGENT_HOST;

// 创建一个 SSE 连接
export const createSSEConnection = async (options) => {
  const { url, data, onMessage, onComplete, onError } = options;
  console.log('createSSEConnection', options);

  let isCancelled = false;
  let reader = null;

  // 返回取消函数
  const cancelConnection = () => {
    isCancelled = true;
    if (reader) {
      try {
        reader.cancel();
      } catch (error) {
        console.log('取消连接时出错:', error);
      }
    }
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: Cookies.get('_t') || '',
      },
      body: JSON.stringify(data),
      mode: 'cors',
    });

    if (!response.body || !response.body.getReader) {
      throw new Error('响应不是一个可读流');
    }

    reader = response.body.getReader(); // 获取 Reader
    const decoder = new TextDecoder();
    let messageList = [];

    while (true) {
      if (isCancelled) {
        console.log('连接已被取消');
        break;
      }

      const { done, value } = await reader.read();
      if (done) {
        console.log('传输完成');
        onComplete && onComplete(messageList);
        break;
      }

      // 解码消息
      const message = decoder.decode(value);
      const messageLines = message.split('\n').filter(Boolean);

      messageLines.forEach((line) => {
        if (isCancelled) return;
        
        try {
          const cleanedLine = line.replace('data: ', '');
          if (cleanedLine) {
            // 已经结束
            if (cleanedLine === '[DONE]') {
              console.log('传输完成');
              return;
            }
            const data = JSON.parse(cleanedLine);
            messageList.push(data);
            onMessage?.(data);
          }
        } catch (e) {
          console.log('错误消息:', message);
          console.log('处理消息行错误:', line, e);
        }
      });
    }
  } catch (error) {
    if (!isCancelled) {
      console.log('错误:', error);
      // 处理错误
      onError && onError(error);
    }
  }

  return cancelConnection;
};

/**
 * AI 写简历
 * @param {string} text
 * @param {number} text_type 1简历润色 2自动写
 * @returns
 */
export const getAIWriteResult = (data) => {
  return request({
    url: `${AI_API}/cv/v3/ai_cvs`,
    method: 'POST',
    data,
    timeout: 60000,
  });
};

/**
 * 获取 AI 模板内
 * @param {string} experience
 * @param {string} job_type
 * @param {string} page
 * @param {string} size
 * @returns
 */
export const getWriteResult = (params) => {
  return request({
    url: `${AI_API}/cv/v3/ai_cvs/template_result`,
    method: 'GET',
    params,
    timeout: 60000,
  });
};

/**
 * AI简历润色
 */

export const getAIOptimizationResult = (data) => {
  return request({
    url: `${AGENT_HOST}/chat/v1/ai_cvs/cv_optimization`,
    method: 'POST',
    data,
    timeout: 60000,
  });
};

export const getOptimizationResultByStream = (options) => {
  const { data, onMessage, onComplete, onError } = options;
  return createSSEConnection({
    url: `${AGENT_STREAM_API_HOST}/chat/v2/ai_cvs/cv_optimization/stream`,
    data,
    onMessage,
    onComplete,
    onError,
  });
};

export const fetchAiResumeChatList = () => {
  return request({
    url: `/v3/cvs/ai_create_cvs`,
    // url: `${AGENT_HOST}/chat/v1/ai_create_cvs`,
    method: 'GET',
    timeout: 60000,
  });
};

export const createAiResume = (data) => {
  return request({
    // url: `/v3/cvs/ai_create_cvs`,
    url: `${AGENT_HOST}/chat/v1/ai_create_cvs`,
    method: 'POST',
    data,
    timeout: 60000,
  });
};

/**
 * @ AI导师-输入检查
 * cv_token 简历token
 * cv 简历内容{}
 * target_position 目标职位
 * job_search_status 求职场景
 * user_concerns 用户关注点
 * @returns
 */
export const aiMentorInputCheck = (data) => {
  return request({
    url: `${AGENT_HOST}/chat/v1/ai_mentor/input_check`,
    method: 'POST',
    data,
    timeout: 60000,
  });
};

/**
 * @ AI导师-简历评估
 * @returns
 */
export const aiMentorCvAssessment = (options) => {
  // return request({
  // 	url: `${AGENT_HOST}/chat/v1/ai_mentor/cv_assessment`,
  // 	method: 'POST',
  // 	data,
  //   timeout: 60000
  // })
  const { data, onMessage, onComplete, onError } = options;
  return createSSEConnection({
    url: `${AGENT_STREAM_API_HOST}/chat/v1/ai_mentor/cv_assessment/stream`,
    data,
    onMessage,
    onComplete,
    onError,
  });
};

/**
 * @ AI导师-职位评估
 * @returns
 */
export const aiMentorJobAssessment = (options) => {
  const { data, onMessage, onComplete, onError } = options;
  return createSSEConnection({
    url: `${AGENT_STREAM_API_HOST}/chat/v1/ai_mentor/job_assessment/stream`,
    data,
    onMessage,
    onComplete,
    onError,
  });
};

/**
 * @ AI导师-简历优化
 * cv_token 简历token
 * cv 简历内容{}
 * cv_analysis  简历分析结果
 * job_analysis  职位分析结果
 * @returns
 */
export const aiMentorOptimization = (data) => {
  return request({
    url: `${AGENT_HOST}/chat/v1/ai_mentor/optimization`,
    method: 'POST',
    data,
    timeout: 60000,
  });
};

/**
 * @ AI导师-生成报告
 * cv_token 简历token
 * cv 简历内容{}
 * cv_analysis  简历分析结果
 * job_analysis  职位分析结果
 * @returns
 */
export const aiMentorReport = (data) => {
  return request({
    url: `${AGENT_HOST}/chat/v1/ai_mentor/report`,
    method: 'POST',
    data,
    timeout: 60000,
  });
};

/**
 * @ AI导师-获取报告
 * cv_token 简历token
 * @returns
 */
export const getAiMentorReport = (params) => {
  return request({
    url: `/v1/ai_mentor/result`,
    method: 'GET',
    params,
  });
};

/**
 * @ AI导师-生成新简历
 * cv_token 简历token
 * @returns
 */
export const createCvOptimization = (data) => {
  return request({
    url: `/v1/ai_mentor/cv_optimization/create`,
    method: 'POST',
    data,
  });
};

export const getAiResumeProfile = (token) => {
  return request({
    url: `/v3/cv_accounts/${token}/profile_default`,
    method: 'GET',
  });
};

export const getAiResumeEdu = (token) => {
  return request({
    url: `/v3/cv_accounts/${token}/edu_default`,
    method: 'GET',
  });
};

export const getTextToResumeResult = (data) => {
  return request({
    url: `${AGENT_HOST}/chat/v1/ai_cvs/imports`,
    method: 'POST',
    data,
  });
};

export const createResumeByIntention = (data) => {
  return request({
    url: `${AGENT_HOST}/chat/v1/ai_cvs/revise`,
    method: 'POST',
    data,
  });
}
